import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const AreaSettingsReserved = forwardRef((props, ref) => {
  let jwt = localStorage.getItem("JWT");
  let link = localStorage.getItem("link");

  let data = props.data;
  let settingsType = props.type;

  const { t } = useTranslation();
  const [reserved, setReserved] = useState(null);
  const [originalReserved, setOriginalReserved] = useState(null);
  const [saving, setSaving] = useState(false);

  const isDirty = () => reserved !== originalReserved;

  const save = async () => {
    if (!isDirty() || saving) return;

    setSaving(true);

    try {
      await axios.put(
        link + "/api/" + settingsType + "/Reserved?reserved=" + reserved,
        data.ids,
        {},
      );

      setOriginalReserved(reserved);
    } finally {
      setSaving(false);
    }
  };

  const reset = () => {
    setReserved(originalReserved);
  };

  useImperativeHandle(
    ref,
    () => ({
      save,
      reset,
      isDirty,
    }),
    [originalReserved, reserved],
  );

  useEffect(() => {
    if (data?.reserved !== undefined) {
      setReserved(Boolean(data.reserved));
      setOriginalReserved(Boolean(data.reserved));
    }
  }, [props.data]);

  const onChangeReserved = (value) => {
    setReserved(value);
  };

  const styleOn = reserved
    ? { backgroundColor: "#20a0ff", color: "white" }
    : {};

  const styleOff = !reserved
    ? { backgroundColor: "#20a0ff", color: "white" }
    : {};

  return (
    <div className="settings-groups">
      <div className="settings-name">
        {t("elementeAllgemein.areaWerte.Reserved")}
      </div>

      <div className="flex-sa">
        <button
          className="button"
          style={styleOn}
          onClick={() => onChangeReserved(true)}
          disabled={saving}
        >
          {t("allgemein.an")}
        </button>

        <button
          className="button"
          style={styleOff}
          onClick={() => onChangeReserved(false)}
          disabled={saving}
        >
          {t("allgemein.aus")}
        </button>
      </div>
    </div>
  );
});

export default AreaSettingsReserved;
